import React from 'react'

const HomePoster = () => {
  return (
    <div className='poster dark-background content'>
        <div className='poster-info'>
            <div>
                <h1>Find your next Book</h1>
            </div>
            <div>
                <p><span>Not sure what to read next?</span> Explore our catalog of public domain books with our editors.</p>
            </div>
            <a href="#popular-books">
              <button className='primary-button'>Explore</button>
            </a>
        </div>
    </div>
  )
}

export default HomePoster